import type { Plugin } from "chart.js";

/**
 * Draws the mastery criterion as a horizontal dashed line with its label.
 * Renders nothing when no criterion applies to the chart.
 *
 * @param masteryCriterion - Threshold on the y scale, or undefined to skip
 * @param label            - Text drawn above the line, e.g. "80% Mastery"
 * @param lineColor        - Stroke and text color
 * @param fontFamily       - Font used for the label
 */
export function buildMasteryCriterionPlugin(
  masteryCriterion: number | undefined,
  label: string,
  lineColor: string,
  fontFamily: string
): Plugin<"line"> {
  return {
    id: "targetChartMasteryCriterion",
    afterDraw(chart) {
      if (masteryCriterion == null) return;
      const { ctx, scales, chartArea } = chart;
      const yScale = scales["y"];
      if (!yScale || !chartArea) return;

      const y = yScale.getPixelForValue(masteryCriterion);

      ctx.save();
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = 1.5;
      ctx.setLineDash([6, 4]);
      ctx.beginPath();
      ctx.moveTo(chartArea.left, y);
      ctx.lineTo(chartArea.right, y);
      ctx.stroke();
      ctx.setLineDash([]);

      // Label
      ctx.fillStyle = lineColor;
      ctx.font = `400 11px ${fontFamily}`;
      ctx.textAlign = "left";
      ctx.textBaseline = "bottom";
      ctx.fillText(label, chartArea.left + 4, y - 4);

      ctx.restore();
    },
  };
}
